"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Textarea_1 = __importDefault(require("./Textarea"));
exports.default = Textarea_1.default;
